import React from 'react';

/**
 * Accessible toggle. Renders a real button with role="switch", keyboard
 * operable (Space/Enter), replacing the non-interactive <div onClick> toggle.
 */
const Switch = ({ checked = false, onChange, label, disabled = false, className = '' }) => (
  <button
    type="button"
    role="switch"
    aria-checked={checked}
    aria-label={label}
    disabled={disabled}
    onClick={() => !disabled && onChange?.(!checked)}
    className={`
      relative inline-flex h-6 w-11 shrink-0 items-center rounded-full
      transition-colors duration-normal ease-out
      focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent focus-visible:ring-offset-2 focus-visible:ring-offset-surface-0
      ${checked ? 'bg-accent' : 'bg-surface-4'}
      ${disabled ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}
      ${className}
    `.replace(/\s+/g, ' ').trim()}
  >
    <span
      className={`
        inline-block h-5 w-5 rounded-full bg-surface-0 shadow-sm
        transition-transform duration-normal ease-spring
        ${checked ? 'translate-x-[1.375rem]' : 'translate-x-0.5'}
      `.replace(/\s+/g, ' ').trim()}
    />
  </button>
);

export default Switch;
